import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useImportContext } from './import-context';
import { StepInfo } from './step-info/step-info';
import { WorkflowSteps } from '../../../../tracking/use-workflow-tracking';
import { HelpArticleLink } from '../../../help-article-link';

/**
 * @typedef {object} ImportDescriptionProps
 * @property {string} file
 * @property {string} articleId
 * @property {import('../../../../prop-types/intl').MessageDescriptorPropType} message
 * @property {string} [className]
 */

/**
 * @type {React.NamedExoticComponent<ImportDescriptionProps>}
 * @returns {React.JSX.Element}
 */
export const ImportDescription = memo(({ message, file, articleId, className }) => {
  const { trackProcess } = useImportContext();

  return (
    <StepInfo className={className}>
      <FormattedMessage
        {...message}
        values={{
          file: (chunks) => (
            <a href={file} onClick={() => trackProcess(WorkflowSteps.CSV_IMPORT_DOWNLOAD_SAMPLE)} target='blank'>
              {chunks}
            </a>
          ),
          helpLink: (chunks) => <HelpArticleLink articleId={articleId}>{chunks}</HelpArticleLink>,
        }}
      />
    </StepInfo>
  );
});
